import { render, staticRenderFns } from "./GroupUserExamResult.vue?vue&type=template&id=ff4d1930&"
import script from "./GroupUserExamResult.vue?vue&type=script&lang=ts&"
export * from "./GroupUserExamResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports